// plugins/store-init.js
import { getStoreModule } from '~/managers/stores.js';

export default ({ store, $config }) => {
    const requireModule = getStoreModule($config.THEME)

    requireModule.keys().forEach(fileName => {
        const moduleConfig = requireModule(fileName).default
        const moduleName = fileName?.replace(/(\.\/|\.js)/g, '')

        if (!store.hasModule(moduleName)) {
            store.registerModule(moduleName, moduleConfig)
        }
    })
}